import { render, staticRenderFns } from "./HistoryDetailLink.vue?vue&type=template&id=4f903d97&scoped=true&"
import script from "./HistoryDetailLink.vue?vue&type=script&lang=js&"
export * from "./HistoryDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f903d97",
  null
  
)

export default component.exports